export default function CivilServiceCommissionMembership() {
    return (
        <div>
<h4>Members</h4>
                  <hr/>
                  <p>
                  <b>Clay Aberts</b>
                  <br/>
                  Term Expires: January 2031
                  </p>
                  <p>
                  <b>Barbara Bower</b>
                  <br/>
                  Term Expires: January 2030
                  </p>
                  <p>
                  <b>Jan Burger</b>&nbsp;<i>Alternate</i>
                  <br/>
                  Term Expires: January 2031
                  </p>
                  <p>
                  <b>Rebecca Guzman</b>&nbsp;<i>Alternate</i>
                  <br/>
                  Term Expires: January 2031
                  </p>
                  <p>
                  <b>Matt Wiedenhaefer</b>
                  <br/>
                  Term Expires: January 2029
                  </p>
                  </div>
    )
}
